import * as React from 'react';
import axios from "axios";
import { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Paper from '@mui/material/Paper';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { red } from "@mui/material/colors";
import Button from '@mui/material/Button';
import Rating from '@mui/material/Rating';
import Switch from '@mui/material/Switch';
import Container from '@mui/material/Container';
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import CircularProgress from '@mui/material/CircularProgress';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';

import FormGroup from '@mui/material/FormGroup';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import PictureAsPdfTwoToneIcon from '@mui/icons-material/PictureAsPdfTwoTone';

import AdminMenuComponent from "../../../components/admin/AdminMenuComponent.js";

import CreateProductElementCard from "./CreateProductElementCard.js";

const config = require("../../../constants/constants.js")

const onHover = {
  cursor: "pointer",
  position: "absolute",
  left: "5px",
  top: "-10px",
  transform: "scale(2.7)",
};

const EditProductPageComponent = ({
  categories,
  fetchProduct,
  updateProductApiRequest,
  reduxDispatch,
  saveAttributeToCatDoc,
  imageDeleteHandler,
  uploadHandler,
  uploadImagesApiRequest,
  uploadImagesCloudinaryApiRequest
}) => {

  const navigate = useNavigate();

  const [validated, setValidated] = useState(false);
  const [product, setProduct] = useState({});
  const [updateProductResponseState, setUpdateProductResponseState] = useState({
    message: "",
    error: "",
  });

  const [attributesFromDb, setAttributesFromDb] = useState([]); // for select lists
  const [attributesTable, setAttributesTable] = useState([]); // for html table
  const [categoryChoosen, setCategoryChoosen] = useState("Choose category");
  const [products, setProducts] = useState([]);

  const [categoriaScelta, setCategoriaScelta] = useState("scegli la categoria");  // è la categoria cliccata nelTab
  const [prodottoScelto, setProdottoScelto] = useState("scegli il servizio");     // è il servizio/prodotto cliccata nelTab
  // true/false se valorizzati
  const [isCategoriaScelta, setIsCategoriaScelta] = useState(false);              // è un boleano true/false
  const [isProdottoScelto, setIsProdottoScelto] = useState(false);                // è un boleano true/false
  const [isRisorsaScelta, setIsRisorsaScelta] = useState(false);                  // è un boleano true/false
  const [isSitoScelto, setIsSitoScelto] = useState(false);                        // è un boleano true/false
  const { pageNumParam } = useParams() || 1;
  const { searchQuery } = useParams() || "";
  const [sortOption, setSortOption] = useState("");
  const [paginationLinksNumber, setPaginationLinksNumber] = useState(null);
  const [pageNum, setPageNum] = useState(null);
  const [filters, setFilters] = useState({}); // collect all filters
  const [error, setError] = useState(false);

  const [imageRemoved, setImageRemoved] = useState(false)
  const [isUploading, setIsUploading] = useState("");
  const [imageUploaded, setImageUploaded] = useState(false);

  const { id } = useParams();

  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [note, setNote] = useState("");
  const [color, setColor] = useState("");
  const [count, setCount] = useState(0);
  const [price, setPrice] = useState(0);
  const [isBookable, setIsBookable] = useState(false);
  const [bookingPrice, setBookingPrice] = useState(0);
  const [selectorIsBookable, setSelectorIsBookable] = useState(false);

  const [category, setCategory] = useState("");
  const [images, setImages] = useState([]);
  const [pdfs, setPdfs] = useState([]);
  const [linkHttp, setLinkHttp] = useState("");

  const uploadProductImagesApiRequest = async (images, productId) => {

    console.log("[uploadProductImagesApiRequest]")
    console.log("[uploadProductImagesApiRequest] images=", images)
    console.log("[uploadProductImagesApiRequest] id=", productId)

    const formData = new FormData();
    Array.from(images).forEach((image) => {
      formData.append("images", image);
    });

    console.log("[uploadProductImagesApiRequest] formData=", formData)
    console.log("[uploadProductImagesApiRequest] POST /api/products/admin/upload?productId")

    const { data } = await axios.post("/api/products/admin/upload?productId=" + productId, formData);
    return data;
  };

  const uploadProductPdfApiRequest = async (pdfs, productId) => {

    console.log("[uploadProductPdfApiRequest]")
    console.log("[uploadProductPdfApiRequest] pdfs=", pdfs)
    console.log("[uploadProductPdfApiRequest] id=", productId)

    const formData = new FormData();
    Array.from(pdfs).forEach((pdf) => {
      formData.append("pdfs", pdf);
    });

    console.log("[uploadProductPdfApiRequest] formData=", formData)
    console.log("[uploadProductPdfApiRequest] POST /api/products/admin/uploadpdfs?productId")

    const { data } = await axios.post("/api/products/admin/uploadpdfs?productId=" + productId, formData);
    return data;
  };

  const handleSalva = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const formInputs = {
      name: name,
      description: description,
      note: note,
      count: count,
      color: color,
      price: price,
      isBookable: isBookable,
      bookingPrice: bookingPrice,
      category: category,
      images: images,
      pdfs: pdfs,
      linkHttp: linkHttp,
      attributesTable: attributesTable,
    };

    if (selectorIsBookable) formInputs.isBookable = false;
    if (selectorIsBookable) formInputs.bookingPrice = 0;

    console.log('[handleSubmit] selectorIsBookable =', selectorIsBookable);
    console.log('[handleSubmit] formInputs =', formInputs);

    //if (event.currentTarget.checkValidity() === true) {
    updateProductApiRequest(id, formInputs)
      .then((data) => {
        //if (data.message === "product updated") navigate("/admin/products");
      })
      .catch((er) =>
        setUpdateProductResponseState({
          error: er.response.data.message
            ? er.response.data.message
            : er.response.data,
        })
      );
    //}
    setValidated(true);
    //window.location.assign('/admin/products')
  };

  const handleLoadImage = (event) => {
    const files = Array.from(event.target.files);
    const statusStep = 100 / files.length;

    console.log("[handleLoadImage] event.target.files=" + event.target.files);
    console.log("[handleLoadImage] files.length=" + files.length);
    console.log("[handleLoadImage] id (productId)=" + id);

    /*
    for (let i = 0; i < files.length; i++) {
      // ## controllo dimensione totale
      //
      // uploadItem(files[i]);
      // Here it guarantees that state updated correctly
      // setState(prevStep => prevStep + statusStep);
    }
    */

    setIsUploading("upload files in corso ...");
    uploadProductImagesApiRequest(event.target.files, id)
      .then(data => {
        setIsUploading("upload files completato");
        setImageUploaded(!imageUploaded);
      })
      .catch((er) => setIsUploading(er.response.data.message ? er.response.data.message : er.response.data));
      // DEBUG stacco window.location.assign
      //window.location.assign(`/admin/edit-product/${id}`)
  };

  const [namefilePdf, setNameFilePdf] = useState("");

  const handleLoadPdf = (event) => {
    const files = Array.from(event.target.files);
    const statusStep = 100 / files.length;

    console.log("[handleLoadPdf] event.target.files=" + event.target.files[0].name)
    console.log("[handleLoadPdf] files.length=" + files.length)

    for (let i = 0; i < files.length; i++) {
      // ## controllo dimensione totale
      //
      // uploadItem(files[i]);
      // Here it guarantees that state updated correctly
      // setState(prevStep => prevStep + statusStep);
    }

    setNameFilePdf(event.target.files[0].name);

    setIsUploading("upload files in corso ...");
    uploadProductPdfApiRequest(event.target.files, id)
      .then(data => {
        setIsUploading("upload files completato");
        setImageUploaded(!imageUploaded);
      })
      .catch((er) => setIsUploading(er.response.data.message ? er.response.data.message : er.response.data));
    //window.location.assign(`/admin/edit-product/${id}`)
  };

  useEffect(() => {
    fetchProduct(id)
      .then((product) => {
        setProduct(product)
        console.log(`product =`, product);
        setName(product?.name);
        setDescription(product?.description);
        setNote(product?.note);
        setColor(product?.color);
        setCount(product?.count);
        setPrice(product?.price);
        setIsBookable(product?.isBookable);
        setBookingPrice(product?.bookingPrice);
        setCategory(product?.category);
        setImages(product?.images);
        //setNameFilePdf(product.pdfs[0].path.substr(product.pdfs[0].path.indexOf('.pdf')-36));
        setNameFilePdf(product.pdfs[0].name);
        setPdfs(product?.pdfs);
        setLinkHttp(product?.linkHttp);
        console.log(`name  =`, name);
        console.log(`description  =`, description);
        console.log(`isBookable  =`, isBookable);
        console.log(`category  =`, category);
        console.log(`images  =`, images);
        console.log(`pdfs  =`, pdfs);
      })
      .catch((er) => console.log(er));
  }, [id, imageRemoved, imageUploaded]);

  useEffect(() => {
    let categoryOfEditedProduct = categories.find(
      (item) => item.name === product.category
    );
    if (categoryOfEditedProduct) {
      const mainCategoryOfEditedProduct =
        categoryOfEditedProduct.name.split("/")[0];
      const mainCategoryOfEditedProductAllData = categories.find(
        (categoryOfEditedProduct) =>
          categoryOfEditedProduct.name === mainCategoryOfEditedProduct
      );
      if (
        mainCategoryOfEditedProductAllData &&
        mainCategoryOfEditedProductAllData.attrs.length > 0
      ) {
        setAttributesFromDb(mainCategoryOfEditedProductAllData.attrs);
      }
    }
    setCategoryChoosen(product.category);
    setAttributesTable(product.attrs);
  }, [product]);

  useEffect(() => {
    setColor(product.color);
    //console.log('color = ',category)
  }, [])

  function gotoIndietro(eventKey) {
    eventKey.preventDefault();
    eventKey.stopPropagation();

    window.location.assign('/admin/products')
  }


  function switchIsBookableHandler(statoSelettore) {
    console.log('[switch] statoSelettore =', statoSelettore);
    setSelectorIsBookable(!selectorIsBookable);
    if (!selectorIsBookable) {
      setBookingPrice(0);
      console.log('[switchOFF] bookingPrice =', bookingPrice);
    }
    console.log('[switchOFF] selectorIsBookable =', selectorIsBookable);
    setIsBookable(statoSelettore);
  }

  const handleSelectedFile = (event) => {
    const files = Array.from(event.target.files);
    const statusStep = 100 / files.length;
    for (let i = 0; i < files.length; i++) {
      // uploadItem(files[i]);
      // Here it guarantees that state updated correctly
      // setState(prevStep => prevStep + statusStep);
    }
  };

  const handleChangeCategoria = (event) => {
    setCategoriaScelta(event.target.value);
    setCategory(event.target.value);
  };

  return (

    <Box sx={{ flexGrow: 1 }}>

      <Grid container spacing={2}>

        <AdminMenuComponent></AdminMenuComponent>

        <Box
          paddingLeft={{ xs: 3, md: 3 }}
          paddingRight={{ xs: 3, md: 3 }}
        >

          <Breadcrumbs separator="›" aria-label="breadcrumb"
            size={{ xs: 12, md: 4 }}
            paddingTop={{ xs: 0, md: 0 }}
            paddingLeft={{ xs: 0, md: 0 }}
            paddingRight={{ xs: 1, md: 8 }}
            spacing={{ xs: 2, md: 2 }}
          >
            <Link underline="hover" color="inherit" href="/admin/welcome">
              {config.BC_ADMIN}
            </Link>
            <Link underline="hover" color="inherit" href="/admin/products">
              {config.BC_ADMIN_PRODUCTS}
            </Link>
            <Typography sx={{ color: 'text.primary' }}>{config.BC_ADMIN_PRODUCTS_EDIT}</Typography>
          </Breadcrumbs>

          <Stack
            sx={{
              flexDirection: { xs: "row", md: "row" },
              paddingTop: 2, paddingLeft: 0, paddingRight: 0,
            }}
          >

            <Typography
              sx={{ paddingTop: 0, paddingLeft: 0, paddingRight: 0, }}
              variant="h4"
            >
              <b>Modifica prodotto</b>&nbsp;
            </Typography>
          </Stack>

          <Grid
            useFlexGap
            sx={{
              flexDirection: { xs: "column", md: "row" },
              paddingTop: 2, paddingLeft: 0, paddingRight: 0,
              flexWrap: 'wrap'
            }}
          >

            <Box
              sx={{
                flexDirection: { xs: "column", md: "column" },
              }}
            >

              <Box
                sx={{
                  paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                  height: 30
                }}
              />

              <Paper
                sx={{
                  paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                  background: '#cce0e6'
                }}
                elevation={6}
              >

                <Stack
                  useFlexGap
                  sx={{
                    flexDirection: { xs: "column", md: "row" },
                    paddingTop: 2, paddingLeft: 0, paddingRight: 0,
                    flexWrap: 'wrap'
                  }}
                >
                  <TextField id="id-name" label="Nome" variant="outlined" value={name} defaultValue={name}
                    sx={{
                      width: "45ch",
                      p: { xs: 1, md: 1 },
                      m: { xs: 1, md: 1 },
                    }}
                    onChange={(event) => {
                      setName(event.target.value);
                    }}
                  />

                  <TextField id="id-description" label="Descrizione" variant="outlined" value={description} defaultValue={description}
                    sx={{
                      width: "55ch",
                      p: { xs: 1, md: 1 },
                      m: { xs: 1, md: 1 },
                    }}
                    onChange={(event) => {
                      setDescription(event.target.value);
                    }}
                  />

                  <TextField id="id-note" label="Note" variant="outlined" value={note} defaultValue={note}
                    sx={{
                      width: "65ch",
                      p: { xs: 1, md: 1 },
                      m: { xs: 1, md: 1 },
                    }}
                    onChange={(event) => {
                      setNote(event.target.value);
                    }}
                    multiline
                    rows={3}
                    maxRows={6}
                  />

                  <TextField id="id-color" label="Colore" variant="outlined" value={color} defaultValue={color} type="color"
                    sx={{
                      width: "20ch",
                      p: { xs: 1, md: 1 },
                      m: { xs: 1, md: 1 },
                    }}
                    onChange={(event) => {
                      setColor(event.target.value);
                    }}
                  />

                  <TextField id="id-count" label="Quantità" variant="outlined" type="number" value={count} defaultValue={count}
                    sx={{
                      width: "15ch",
                      p: { xs: 1, md: 1 },
                      m: { xs: 1, md: 1 },
                    }}
                    onChange={(event) => {
                      setCount(event.target.value);
                    }}
                  />

                  <FormControl
                    sx={{
                      width: "20ch",
                      p: { xs: 1, md: 1 },
                      m: { xs: 1, md: 1 },
                    }}
                    onChange={(event) => {
                      setPrice(event.target.value);
                    }}
                  >
                    <InputLabel htmlFor="outlined-adornment-amount">Prezzo</InputLabel>
                    <OutlinedInput
                      id="outlined-adornment-amount"
                      startAdornment={<InputAdornment position="start">€</InputAdornment>}
                      label="Prezzo"
                      type="number"
                      defaultValue={price}
                      value={price}
                    />
                  </FormControl>

                  <Box sx={{
                    paddingLeft: 2,
                    paddingTop: 2
                  }}
                  >

                    <FormControl
                      style={{
                        width: "40ch",
                        p: { xs: 1, md: 1 },
                        m: { xs: 1, md: 1 },
                      }}
                    >
                      <InputLabel id="sel-categoria">Tipo prodotto</InputLabel>
                      <Select
                        labelId="sel-categoria"
                        id="id-sel-categoria"
                        value={category}
                        label="Tipo prodotto"
                        onChange={handleChangeCategoria}
                      >
                        {categories.map(category => {
                          return (
                            <MenuItem key={category.name} value={category.name}>
                              {category.name}
                            </MenuItem>
                          )
                        })}
                      </Select>
                    </FormControl>
                  </Box>

                  <TextField id="id-linkHttp" label="link http" variant="outlined" value={linkHttp} defaultValue={linkHttp}
                    sx={{
                      width: "55ch",
                      p: { xs: 1, md: 1 },
                      m: { xs: 1, md: 1 },
                    }}
                    onChange={(event) => {
                      setLinkHttp(event.target.value);
                    }}
                  />

                  <Box sx={{
                    paddingLeft: 2,
                    paddingTop: 0
                  }}
                  >
                    <Paper
                      sx={{
                        paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                        background: '#edf2f3ff',
                      }}
                      elevation={1}
                    >

                      <Grid container
                        sx={{
                          paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                          p: { xs: 1, md: 1 },
                          m: { xs: 2, md: 2 },
                        }}
                      >

                        <Button
                          variant="contained"
                          color="primary"
                          type="submit"
                          size="small"
                          component="label"
                          fullWidth
                          sx={{
                            width: "20ch",
                            height: "8ch",

                            //borderRadius: 1,
                            borderRadius: 35,
                            backgroundColor: "#141688",
                            paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                          }}
                        >

                          <Stack
                            direction="row"
                            justifyContent="flex-start"
                            alignItems="center"
                          >
                            <Typography
                              sx={{
                                paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                                color: 'white',
                                fontFamily: 'Roboto',
                                textTransform: 'none',
                                fontSize: 18,
                              }}
                            >
                              carica pdf&nbsp;
                              <PictureAsPdfTwoToneIcon
                                //fontSize="inherit"
                                fontSize="medium"
                              >
                              </PictureAsPdfTwoToneIcon>
                            </Typography>
                          </Stack>
                          <input type="file" onChange={handleLoadPdf} hidden accept=".pdf"/>
                        </Button>

                        <TextField id="id-pdf" label="file per il download" variant="outlined" value={namefilePdf}
                          sx={{
                            width: "45ch",
                            paddingTop: 0, paddingBottom: 0, paddingLeft: 0.2, paddingRight: 0,
                          }}
                          InputProps={{
                            readOnly: true,
                          }}
                          onChange={(event) => {
                            //setTitle(event.target.value);
                          }}
                        />

                      </Grid>

                    </Paper>
                  </Box>
                </Stack>

                <Stack
                  sx={{
                    flexDirection: { xs: "row", md: "row" },
                    paddingTop: 2, paddingLeft: 2, paddingRight: 0,
                  }}
                >

                  <FormControlLabel
                    control={<Switch defaultChecked />}
                    checked={isBookable}
                    //onChange={switchIsBookableHandler}
                    onChange={(event) => {
                      switchIsBookableHandler(event.target.checked);
                    }}
                    label="Prenotabile"
                    sx={{
                      paddingTop: 0, paddingLeft: 4, paddingRight: 0,
                    }}
                  />

                  {isBookable &&

                    <Stack
                      sx={{
                        flexDirection: { xs: "row", md: "row" },
                        paddingTop: 2, paddingLeft: 0, paddingRight: 0,
                      }}
                    >

                      <FormControl
                        sx={{ m: 0, paddingTop: 0, paddingLeft: 0, paddingRight: 0, }}
                        style={{
                          width: "20ch",
                        }}
                        onChange={(event) => {
                          setBookingPrice(event.target.value);
                        }}
                      >
                        <InputLabel htmlFor="outlined-adornment-amount">Importo prenotazione</InputLabel>
                        <OutlinedInput
                          id="outlined-adornment-amount"
                          startAdornment={<InputAdornment position="start">€</InputAdornment>}
                          label="Importo prenotazione"
                          type="number"
                          defaultValue={bookingPrice}
                          value={bookingPrice}
                        />
                      </FormControl>

                    </Stack>
                  }

                </Stack>

                <Stack
                  sx={{
                    paddingTop: 1, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                    display: 'flex',
                    flexDirection: { xs: "row", md: "row" },
                    alignItems: "center",
                    justifyContent: "center"
                  }}
                >

                  <Button
                    type="button"
                    variant="contained"
                    color="warning"
                    onClick={(e) => { gotoIndietro(e); }}
                    sx={{
                      width: "12ch",
                      p: 1,
                      m: 1,
                    }}
                  >
                    Indietro
                  </Button>

                  <Button
                    variant="contained"
                    type="submit"
                    color="success"
                    onClick={handleSalva}
                    sx={{
                      width: "12ch",
                      p: 1,
                      m: 1,
                    }}
                  >
                    Salva
                  </Button>
                </Stack>

                <Box
                  sx={{
                    paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                    height: 20
                  }}
                />

              </Paper>

              <Box
                sx={{
                  paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                  height: 30
                }}
              />

              <Paper
                sx={{
                  paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                  background: '#cce0e6'

                }}
                elevation={6}
              >

                <Box
                  sx={{
                    paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                  }}
                >

                  <Stack
                    sx={{
                      paddingTop: 1, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                      display: 'flex',
                      flexDirection: { xs: "row", md: "row" },
                      alignItems: "center",
                      justifyContent: "center"
                    }}
                  >

                    <Button
                      variant="contained"
                      color="primary"
                      type="submit"
                      size="small"
                      component="label"
                      fullWidth
                      sx={{
                        width: "20ch",
                        p: 1,
                        m: 1,
                      }}
                    >
                      Carica immagine
                      <input type="file" onChange={handleLoadImage} hidden accept=".jpg" />
                    </Button>

                    <Typography variant="h6" color="navy"
                      sx={{
                        width: "20ch",
                        p: 1,
                        m: 1,
                        paddingTop: 0, paddingBottom: 0, paddingLeft: 10, paddingRight: 0,
                      }}
                    >
                      {images.length} immagini caricate
                    </Typography>

                    <Typography variant="h9" color="black"
                      sx={{
                        width: "50ch",
                        p: 1,
                        m: 1,
                        paddingTop: 0, paddingBottom: 0, paddingLeft: 10, paddingRight: 0,
                      }}
                    >
                      puoi modificare titoli e info
                    </Typography>

                  </Stack>

                  <Stack
                    sx={{
                      flexDirection: { xs: "row", md: "row" },
                      paddingTop: 0, paddingLeft: 0, paddingRight: 0, paddingBottom: 1,
                      position: "center", overflowX: "scroll",
                      '@media (min-width: 600px)': { width: '1400px' },
                      '!@media (min-width: 600px)': { width: '500px' },
                    }}
                  >

                    {images.map((image, idx) => (

                      <CreateProductElementCard key={idx} imagePath={image.path} idx={idx} pageId={id} nameImage={image.name} titleImage={image.title} subTitleImage={image.subTitle} pageAll={product} />

                    ))}

                  </Stack>

                </Box>

              </Paper>

              <Box
                sx={{
                  paddingTop: 4, paddingBottom: 0, paddingLeft: 0, paddingRight: 0
                }}
              />

            </Box>

          </Grid>

        </Box>

      </Grid>

    </Box>

  );
};

export default EditProductPageComponent;
